export const getCompleteURL = () => {
  const pathname = window.location.pathname;
  return pathname.endsWith("/") ? pathname.slice(0, -1) : pathname;
};
